module.exports = __webpack_public_path__ + "static/more-f7269efab4e0fe1542f7afc9cff92973.jpg";